export default __webpack_public_path__ + "static/media/diamond-cut-4.c6297197.jpg";